import React, { useEffect, useState } from "react";
import { API, fetchSponsors, trackSponsor } from "../lib/api";

export default function SponsorRotator({ variant = "map" }) {
  const [sponsors, setSponsors] = useState([]);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    fetchSponsors().then(setSponsors).catch(() => {});
  }, []);

  useEffect(() => {
    if (sponsors.length < 2) return;
    const id = setInterval(() => setIdx((i) => (i + 1) % sponsors.length), 15000);
    return () => clearInterval(id);
  }, [sponsors.length]);

  const current = sponsors.length ? sponsors[idx % sponsors.length] : null;

  useEffect(() => {
    if (current?.id) trackSponsor(current.id, "impression", variant);
  }, [current?.id, variant]);

  if (!current) return null;
  const s = current;
  const logo = s.has_logo ? `${API}/sponsors/${s.id}/logo` : null;
  const onClick = () => trackSponsor(s.id, "click", variant);

  const content = (
    <>
      <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-tac-dim shrink-0">
        Supporters
      </span>
      {logo && <img src={logo} alt={s.name} className="h-14 max-w-[180px] object-contain shrink-0" />}
      <span className="text-[14px] font-bold text-tac-text truncate">{s.name}</span>
    </>
  );

  if (variant === "strip") {
    return (
      <div className="border border-tac-border bg-tac-surface/40 mb-6 px-4 py-2.5" data-testid="sponsor-strip">
        {s.link_url ? (
          <a
            href={s.link_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sponsor-strip-link"
            onClick={onClick}
            className="flex items-center gap-3 hover:opacity-80 transition-opacity"
          >
            {content}
          </a>
        ) : (
          <div className="flex items-center gap-3">{content}</div>
        )}
      </div>
    );
  }

  if (variant === "inline") {
    const inlineContent = (
      <>
        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-tac-dim">
          Supporters
        </span>
        {logo && <img src={logo} alt={s.name} className="h-14 max-w-[180px] object-contain" />}
        <span className="text-[14px] font-bold text-tac-text truncate max-w-full">{s.name}</span>
      </>
    );
    return (
      <div className="mt-4 pt-3 border-t border-tac-border/60" data-testid="sponsor-inline">
        {s.link_url ? (
          <a
            href={s.link_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="sponsor-inline-link"
            onClick={onClick}
            className="flex flex-col items-center gap-1.5 text-center hover:opacity-80 transition-opacity"
          >
            {inlineContent}
          </a>
        ) : (
          <div className="flex flex-col items-center gap-1.5 text-center">{inlineContent}</div>
        )}
      </div>
    );
  }

  const inner = (
    <div className="flex items-center gap-1.5 px-2 py-1 bg-tac-bg/85 backdrop-blur-xl border border-tac-border rounded-sm max-w-[65vw] sm:max-w-[300px]">
      <span className="text-[8px] sm:text-[9px] font-bold uppercase tracking-[0.14em] text-tac-dim shrink-0 whitespace-nowrap">
        Supporters
      </span>
      {logo && <img src={logo} alt={s.name} className="h-9 max-w-[130px] object-contain shrink-0" />}
      <span className="text-[11px] font-bold text-tac-text truncate">{s.name}</span>
    </div>
  );

  return (
    <div className="absolute bottom-3 right-1 sm:bottom-1 z-[1000]" data-testid="sponsor-map-card">
      {s.link_url ? (
        <a href={s.link_url} target="_blank" rel="noopener noreferrer" data-testid="sponsor-map-link" onClick={onClick} className="block hover:opacity-90 transition-opacity">
          {inner}
        </a>
      ) : (
        inner
      )}
    </div>
  );
}

